import {Link} from '@mui/material';
import React, {PropsWithChildren} from "react";

interface Props {
	text: string;
}
export const Nl2BrText = ({ text }: Props) => {
	return <div dangerouslySetInnerHTML={{ __html: text.replaceAll('\n', '<br/>') || '' }}></div>
};
